import './common';
import './responsive_slider';
import './share_buttons';

$("table").each(function(index) {
	$(this).addClass("mobile_table");
	$("table.mobile_table span").removeAttr("style");
});

//Add noprint class to all wistia videos in help pages
var wistiaEmbed = $(".wistia_embed");
for(var i=0;i<wistiaEmbed.length;i++){
	wistiaEmbed.eq(i).addClass("noprint");
}
